import * as types from '../../index';

export const aflt_skillListAction = (data) => {
    return {
    type: types.SKILL_LIST_AFFILIATE,
    data
    }
};

export const aflt_skillAddAction = (data) => {
    return {
    type: types.SKILL_ADD_AFFILIATE,
    data
    }
};

export const aflt_skillEditAction = (data) => {
    return {
    type: types.SKILL_EDIT_AFFILIATE,
    data
    }
};

export const aflt_skillUpdateAction = (data) => {
    return {
    type: types.SKILL_UPDATE_AFFILIATE,
    data
    }
};

export const aflt_skillDeleteAction = (data) => {
    return {
    type: types.SKILL_DELETE_AFFILIATE,
    data
    }
};

export const updateSkillIndexAction = (data) => { 
    return { 
        type: types.UPDATE_SKILL_INDEX,
        data
    }
};

export const skillSuggestionAction = (data) => { 
    return { 
        type: types.SKILL_SUGGESTION,
        data
    }
};